import { StageTools } from '../types';

export const SCALABLE_GROWTH_TOOLS: StageTools = [
  {
    category: "增长分析",
    tools: [
      {
        name: "Amplitude",
        icon: "",
        description: "产品分析平台，帮助理解用户行为",
        url: "https://amplitude.com",
        tags: ["数据分析", "用户行为"]
      },
      {
        name: "Mixpanel",
        icon: "",
        description: "产品分析工具，追踪用户转化",
        url: "https://mixpanel.com",
        tags: ["数据分析", "转化分析"]
      }
    ]
  },
  {
    category: "用户体验",
    tools: [
      {
        name: "Hotjar",
        icon: "",
        description: "热图分析和用户行为录制工具",
        url: "https://www.hotjar.com",
        tags: ["用户体验", "行为分析"]
      },
      {
        name: "Optimizely",
        icon: "",
        description: "A/B测试和个性化体验平台",
        url: "https://www.optimizely.com",
        tags: ["A/B测试", "用户体验"]
      }
    ]
  },
  {
    category: "运营分析",
    tools: [
      {
        name: "ChartMogul",
        icon: "",
        description: "订阅收入分析和指标追踪",
        url: "https://chartmogul.com",
        tags: ["收入分析", "指标追踪"]
      },
      {
        name: "Baremetrics",
        icon: "",
        description: "SaaS指标分析和预测",
        url: "https://baremetrics.com",
        tags: ["指标分析", "收入预测"]
      }
    ]
  }
]; 